if (!customElements.get('cart-gift-wrap')) {
  customElements.define(
    'cart-gift-wrap',
    class CartGiftWrap extends HTMLElement {
      connectedCallback() {
        this.wrapCheckbox = this.querySelector('[data-wrap-checkbox]');
        this.gallery = this.querySelector('[data-wrap-gallery]');
        this.wrapCheckbox?.addEventListener('change', () => {
          if (this.gallery) {
            this.gallery.hidden = !this.wrapCheckbox.checked;
            this.toggleSlideshow(this.wrapCheckbox.checked);
          }
          this.save();
        });
        this.setupGallery();
        this.checkbox = this.querySelector('[data-gift-checkbox]');
        this.messageWrap = this.querySelector('[data-gift-message]');
        this.textarea = this.querySelector('[data-gift-textarea]');
        this.toInput = this.querySelector('[data-gift-to]');
        this.fromInput = this.querySelector('[data-gift-from]');
        this.previewTo = this.querySelector('[data-preview-to]');
        this.previewFrom = this.querySelector('[data-preview-from]');
        this.previewMessage = this.querySelector('[data-preview-message]');

        this.checkbox.addEventListener('change', () => {
          const on = this.checkbox.checked;
          this.messageWrap.hidden = !on;
          if (on) this.toInput?.focus({ preventScroll: true });
          this.save();
        });

        let timer;
        [this.textarea, this.toInput, this.fromInput].forEach((field) => {
          field?.addEventListener('input', () => {
            if (this.flip?.classList.contains('is-front')) this.showSide(false);
            this.renderPreview();
            clearTimeout(timer);
            timer = setTimeout(() => this.save(), 400);
            this.setValidated(false);
          });
        });

        // Bouton « Valider ma carte » : confirme l'enregistrement à la cliente.
        this.validateButton = this.querySelector('[data-gift-validate]');
        this.validateStatus = this.querySelector('[data-gift-status]');
        this.validateButton?.addEventListener('click', () => {
          clearTimeout(timer);
          if (!this.textarea.value.trim()) {
            this.validateStatus.textContent = this.dataset.labelEmpty;
            this.validateStatus.classList.add('is-error');
            this.textarea.focus();
            return;
          }
          this.validateButton.disabled = true;
          this.save().then((ok) => {
            this.validateButton.disabled = false;
            if (ok) {
              this.setValidated(true);
            } else {
              this.validateStatus.textContent = this.dataset.labelError;
              this.validateStatus.classList.add('is-error');
            }
          });
        });
        if (this.textarea.value.trim()) this.setValidated(true);

        // Carte recto verso : le verso (avec le message) s'affiche par défaut.
        this.flip = this.querySelector('[data-card-flip]');
        this.flipButton = this.querySelector('[data-card-flip-button]');
        this.flipLabel = this.querySelector('[data-card-flip-label]');
        this.flipButton?.addEventListener('click', () => this.showSide(!this.flip.classList.contains('is-front')));

        this.renderPreview();
      }

      // Photos de l'emballage : défilent seules quand la case est cochée.
      setupGallery() {
        if (!this.gallery) return;
        this.slidesEl = this.gallery.querySelector('[data-wrap-slides]');
        this.slides = [...this.gallery.querySelectorAll('[data-wrap-slide]')];
        this.dots = [...this.gallery.querySelectorAll('[data-wrap-dot]')];
        this.slideIndex = 0;
        this.slidesEl.addEventListener(
          'scroll',
          () => {
            const width = this.slidesEl.clientWidth || 1;
            this.slideIndex = Math.round(Math.abs(this.slidesEl.scrollLeft) / width);
            this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.slideIndex));
          },
          { passive: true }
        );
        ['pointerdown', 'touchstart', 'focusin'].forEach((type) =>
          this.slidesEl.addEventListener(type, () => this.toggleSlideshow(false), { passive: true })
        );
        this.gallery.querySelector('[data-wrap-prev]')?.addEventListener('click', () => {
          this.toggleSlideshow(false);
          this.goToSlide(this.slideIndex - 1);
        });
        this.gallery.querySelector('[data-wrap-next]')?.addEventListener('click', () => {
          this.toggleSlideshow(false);
          this.goToSlide(this.slideIndex + 1);
        });
        if (!this.gallery.hidden) this.toggleSlideshow(true);
      }

      goToSlide(index) {
        const count = this.slides.length;
        const target = ((index % count) + count) % count;
        const direction = document.documentElement.dir === 'rtl' ? -1 : 1;
        this.slidesEl.scrollTo({ left: direction * target * this.slidesEl.clientWidth, behavior: 'smooth' });
      }

      toggleSlideshow(on) {
        clearInterval(this.slideTimer);
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!on || reduced || !this.slides || this.slides.length < 2) return;
        this.slideTimer = setInterval(() => this.goToSlide(this.slideIndex + 1), 3200);
      }

      showSide(front) {
        if (!this.flip) return;
        this.flip.classList.toggle('is-front', front);
        this.querySelector('[data-card-front]')?.setAttribute('aria-hidden', String(!front));
        this.querySelector('[data-card-back]')?.setAttribute('aria-hidden', String(front));
        if (this.flipLabel) {
          this.flipLabel.textContent = front ? this.flipButton.dataset.labelBack : this.flipButton.dataset.labelFront;
        }
      }

      // La carte affichée suit en direct ce que la cliente écrit.
      renderPreview() {
        if (this.previewTo) this.previewTo.textContent = this.toInput?.value.trim() || '';
        if (this.previewFrom) this.previewFrom.textContent = this.fromInput?.value.trim() || '';
        if (this.previewMessage) {
          const text = this.textarea.value.trim();
          this.previewMessage.textContent = text || this.previewMessage.dataset.placeholder || '';
          this.previewMessage.classList.toggle('is-placeholder', !text);
        }
      }

      save() {
        // Emballage et carte sont deux choix indépendants.
        const on = this.checkbox.checked;
        // Une valeur vide retire l'information de la commande.
        const attributes = {
          'Emballage cadeau': this.wrapCheckbox?.checked ? 'Oui' : '',
          'Carte cadeau': on ? 'Oui' : '',
          'Carte - Pour': on && this.toInput ? this.toInput.value.trim() : '',
          'Carte - Offert par': on && this.fromInput ? this.fromInput.value.trim() : '',
          'Message carte cadeau': on ? this.textarea.value.trim() : '',
        };
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes }),
        })
          .then((response) => response.ok)
          .catch(() => false);
      }

      setValidated(done) {
        if (!this.validateButton) return;
        this.validateButton.textContent = done ? this.dataset.labelValidated : this.dataset.labelValidate;
        this.validateButton.classList.toggle('is-validated', done);
        this.validateStatus.classList.remove('is-error');
        this.validateStatus.textContent = done ? this.dataset.labelSaved : '';
      }
    }
  );
}
